module.exports = __webpack_public_path__ + "static/media/lewy-dol-atmo.a4eb0543.svg";